import { RentalType } from '../common/consts';
// Singleton class that stores the city identifier for the current place
// We need to do this so that we can access the cityIdentifer from standard .js files
// e.g. apiAccess.js
class APIManager {
  static instance;
  cityIdentifier = '';
  rentalType = RentalType.STR;
  constructor(cityIdentifier, rentalType) {
    if (APIManager.instance) {
      return APIManager.instance;
    }

    APIManager.instance = this;
    this.cityIdentifier = cityIdentifier;
    this.rentalType = rentalType;
    return this;
  }

  getPlaceUrl() {
    if (this.rentalType === RentalType.LTR) {
      return `lotr-${this.cityIdentifier}`;
    }
    return this.cityIdentifier;
  }
}

export function getAPIManagerInstance(cityIdentifier, rentalType) {
  return new APIManager(cityIdentifier, rentalType);
}
